module.exports = __webpack_public_path__ + "ab8f4db4b9ded430675738a636dbcfa1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/owls/default-owl-6.png
// module id = 1731
// module chunks = 0